export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100/60">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-2xl mx-auto bg-background-50 rounded-xl p-6 md:p-10">
          <div className="flex items-start gap-4 md:gap-6">
            <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-accent-100/80 rounded-lg flex-shrink-0">
              <i className="ri-mail-send-line text-xl md:text-2xl text-accent-600"></i>
            </div>
            <div>
              <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-2">联系我们</h2>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-5">
                如果你有漫画资源推荐、版权合作需求，或对飞飞漫画网有任何建议与反馈，欢迎通过以下方式与我们取得联系。我们重视每一位读者的声音，期待与你一起打造更好的漫画全集阅读平台。
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <a
                  href="#hero"
                  className="flex items-center justify-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer no-underline"
                >
                  <i className="ri-chat-3-line text-lg"></i>
                  <span>投稿与合作</span>
                </a>
                <a
                  href="#faq"
                  className="flex items-center justify-center gap-2 px-5 py-2.5 bg-background-100 hover:bg-background-200 text-foreground-700 font-medium text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer no-underline"
                >
                  <i className="ri-question-line text-lg"></i>
                  <span>查看常见问题</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}